import { render, staticRenderFns } from "./CaixaPostalView.vue?vue&type=template&id=2d87ea90&"
import script from "./CaixaPostalView.vue?vue&type=script&lang=js&"
export * from "./CaixaPostalView.vue?vue&type=script&lang=js&"
import style0 from "./CaixaPostalView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports